import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectLocationsService {
  private companyID: any;
  private endpoint: string | null = null;
  constructor(private baseService: BaseService) {}

  fetchProjectLocations(): Observable<any> {
    return this.baseService.get(`kiosk/projects`);
  }
}
